/**
 * Datapoint configurations.
 */
export default {
    ShowFullOptions: {
        datapoint: {
            name: 'ShowFullOptions',
        },
    },
};
